import { Buttons, RibbonEl, TrainMask } from '@widgets/carousel/carousel';
import '@widgets/carousel/carousel.scss';
import React from 'react';
export default function VideoHero({ title, buttons, video }) {
    return React.createElement("div", { className: `ltg-carousel-wrap` },
        React.createElement("div", { className: `${THEME === 'museum' ? '' : 'ml-'}container` },
            React.createElement("div", { className: `ltg-carousel ltg-carousel--${THEME}` },
                React.createElement("div", { className: "ltg-carousel-text-wrap" },
                    React.createElement("div", { className: "ltg-carousel-text" },
                        React.createElement("div", { className: "ltg-carousel-carousel-text" },
                            React.createElement("div", { className: "ltg-carousel-heading" }, title)),
                        (buttons === null || buttons === void 0 ? void 0 : buttons.length) > 0 && React.createElement(Buttons, { buttons: buttons }))),
                React.createElement("div", { className: "ltg-carousel-img-col" },
                    React.createElement("div", { className: `ltg-carousel-img-wrap` },
                        React.createElement(TrainMask, null),
                        video &&
                            React.createElement("video", { autoPlay: true, muted: true, loop: true, className: 'ltg-carousel-img', src: video.url }))))),
        React.createElement(RibbonEl, null));
}
